import { isIdle } from '@wix/toolbelt';
import { Scope } from './domain';
import { setPresence, updatePresence, } from '@wix/ambassador-presence-v2-presence/http';
import { Scope as ScopeV2, PresenceStatus, } from '@wix/ambassador-presence-v2-presence/types';
import { KEEP_ALIVE_TIME } from './constants';
import { uuid } from './utils';
const IDLE_TIME = 1000 * 60 * 10; // 10 min
export default class GroupV2 {
    constructor({ getPresenceConnection, scope, httpClient, getInitialState = () => ({}), keepAliveInterval = KEEP_ALIVE_TIME, isIdleMs, onIdle, onActive, }) {
        this.sessionId = uuid();
        this.onDisconnectFn = () => { };
        this.shouldWatchGroup = true;
        this.onIdle = () => {
            void this.updatePresence({});
            this.onIdleFn();
        };
        this.onActive = async () => {
            try {
                await this.onActiveFn();
            }
            finally {
                void this.refreshState();
            }
        };
        this.onSubscribe = async () => {
            await this.createState(this.getInitialState());
            await this.keepAlive();
            this.idle.listen();
        };
        this.getPresenceConnection = getPresenceConnection;
        this.keepAliveInterval = keepAliveInterval;
        this.scope = this.convertScope(scope);
        this.isIdleMs = window.__PRESENCE_IDLE_TIME ?? isIdleMs ?? IDLE_TIME;
        this.onIdleFn = onIdle ?? (() => { });
        this.onActiveFn = onActive ?? (() => { });
        this.getInitialState = getInitialState;
        this.idle = isIdle({
            isIdleTime: this.isIdleMs,
            onIdle: this.onIdle,
            onActive: this.onActive,
        });
        this.httpClient = httpClient;
    }
    track(opts) {
        this.shouldWatchGroup = opts?.watchGroup ?? this.shouldWatchGroup;
        this.connection = this.getPresenceConnection();
        const info = {
            presenceSessionId: this.sessionId,
            watchGroup: opts?.watchGroup,
        };
        this.connection.on('@duplexer:disconnected', this.onDisconnectFn);
        return this.connection
            .subscribe(this.getConnectionScope(this.scope), { info })
            .on('@duplexer:subscription_succeeded', this.onSubscribe);
    }
    disconnect() {
        if (this.connection) {
            this.connection.disconnect();
            this.connection = undefined;
        }
    }
    onDisconnect(onDisconnectFn) {
        this.onDisconnectFn = onDisconnectFn;
    }
    async createState(payload) {
        const presence = {
            payload,
            scope: this.scope,
            sessionId: this.sessionId,
            status: PresenceStatus.ACTIVE,
        };
        await this.httpClient.request(setPresence({ presence }));
    }
    async updateState(state) {
        if (this.connection) {
            await this.httpClient.request(updatePresence(state));
        }
    }
    preparePayload(payload = {}) {
        const fullPayload = {
            lastActiveDate: new Date(),
            ...payload,
        };
        const mask = Object.keys(fullPayload).map((key) => `payload.${key}`);
        return { payload: fullPayload, mask };
    }
    async updatePresence(payload, predefinedMask = []) {
        const { payload: fullPayload, mask: payloadMask } = this.preparePayload(payload);
        const mask = Array.from(new Set(payloadMask.concat(predefinedMask)));
        await this.updateState({
            mask,
            presence: {
                payload: fullPayload,
                scope: this.scope,
                sessionId: this.sessionId,
                status: PresenceStatus.ACTIVE,
            },
        });
    }
    getSessionId() {
        return this.sessionId;
    }
    refreshState() {
        return this.updatePresence({});
    }
    async keepAlive() {
        if (!this.connection) {
            clearTimeout(this.keepAliveTimer);
            return;
        }
        await this.refreshState().catch(() => { });
        if (this.keepAliveTimer) {
            clearTimeout(this.keepAliveTimer);
        }
        this.keepAliveTimer = setTimeout(() => this.keepAlive(), this.keepAliveInterval);
    }
    getConnectionScope(scope) {
        switch (scope) {
            case ScopeV2.VIEWER:
                return Scope.VIEWER;
            case ScopeV2.EDITOR_X:
                return Scope.EDITOR_X;
            default:
                return '';
        }
    }
    convertScope(scope) {
        switch (scope) {
            case Scope.EDITOR_X:
                return ScopeV2.EDITOR_X;
            case Scope.VIEWER:
                return ScopeV2.VIEWER;
            default:
                return ScopeV2.UNDEFINED;
        }
    }
}
//# sourceMappingURL=group-v2.js.map